<template>
  <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex md4>
          <v-autocomplete
            v-model="form.pais_nacimiento"
            :items="paises"
            item-text="pais"
            :item-value="(val) => parseInt(val.id)"
            label="País de nacimiento"
            :rules="$validate(['required'])"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex md4>
          <v-autocomplete
            v-model="form.id_parametro_departamento"
            :items="departamentos"
            item-text="valor"
            :item-value="(val) => parseInt(val.id)"
            :disabled="
              form.pais_nacimiento != 120 || (this.estado == 0)
            "
            :rules="form.pais_nacimiento == 120 ? $validate(['required']) : []"
            label="Departamento de nacimiento"
          ></v-autocomplete>
        </v-flex>
        <v-flex md4>
          <v-autocomplete
            :items="paises"
            item-text="pais"
            item-value="id"
            v-model="form.nacionalidad"
            label="Nacionalidad"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex md3>
          <v-autocomplete
            :items="paises"
            item-text="pais"
            :item-value="(val) => parseInt(val.id)"
            v-model="form.pais_residencia"
            label="Pais de Residencia"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex xs3>
          <v-autocomplete
            :items="ciudades"
            item-text="ciudad"
            :item-value="(val) => parseInt(val.id)"
            v-model="form.ciudad_residencia"
            label="Ciudad de Residencia"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex md3>
          <v-autocomplete
            :items="generos"
            item-text="valor"
            :item-value="(val) => parseInt(val.id)"
            v-model="form.id_genero"
            label="Genero"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex md3>
          <v-text-field
            v-model="form.fecha_nacimiento"
            :rules="$validate(['required'])"
            required
            label="Fecha de nacimiento"
            type="date"
            :disabled="this.estado == 0"
          >
          </v-text-field>
        </v-flex>
        <v-flex md2>
          <v-autocomplete
            v-model="form.id_parametro_estado_civil"
            :items="estado_civil"
            item-text="valor"
            :item-value="(val) => parseInt(val.id)"
            label="Estado Civil"
            :rules="$validate(['required'])"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>

        <v-flex md4>
          <v-text-field
            ref="zona"
            v-model="form.zona"
            :rules="$validate(['required'])"
            label=" Zona"
            required
            placeholder="Zona"
            class="mayuscula"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md4>
          <v-text-field
            ref="direccion"
            v-model="form.direccion"
            :rules="$validate(['required'])"
            label="Calle o Avenida/ Nro. de vivienda"
            required
            placeholder="Dirección"
            class="mayuscula"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>

        <v-flex md2>
          <v-text-field
            type="number"
            label="Teléfono Domicilio"
            required
            v-model="form.telefono_domicilio"
            :rules="[
              (v) => {
                if (v < 0) return 'Los numeros no pueden ser negativos';
                return true;
              },
            ]"
            maxlength="25"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md3>
          <v-text-field
            type="number"
            label="Teléfono Alternativo"
            required
            v-model="form.telefono_alternativo"
            :rules="[
              (v) => !!v || 'Este campo es obligatorio',
              (v) => {
                if (v < 0) return 'Los numeros no pueden ser negativos';
                return true;
              },
            ]"
            maxlength="25"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md3>
          <v-text-field
            type="number"
            label="Celular"
            required
            v-model="form.celular"
            :rules="[
              (v) => {
                if (v < 0) return 'Los numeros no pueden ser negativos';
                return true;
              },
            ]"
            maxlength="25"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md3>
          <v-text-field
            label="Correo Electrónico Personal"
            required
            v-model="form.correo_personal"
            :rules="$validate(['email', 'required'])"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md3>
          <v-text-field
            label="Cuenta Facebook"
            required
            v-model="form.cuenta_facebook"
            :rules="$validate(['required'])"
            maxlength="100"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md3>
          <v-text-field
            label="Cuenta Twitter"
            required
            v-model="form.cuenta_twitter"
            maxlength="50"
            :disabled="this.estado == 0 "
          ></v-text-field>
        </v-flex>
        <v-flex md3>
          <v-autocomplete
            v-model="form.id_parametro_grupo_sanguineo"
            :items="tipo_sangre"
            item-text="valor"
            :item-value="(val) => parseInt(val.id)"
            label="Grupo Sanguíneo"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-card-text class="grey lighten-2 text--info">
          <v-layout wrap>
            <v-flex class="px-3">
              <strong> Documentos personales </strong>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-flex md4>
          <v-autocomplete
            v-model="form.id_parametro_entidad_previsora"
            :items="entidad_previsora"
            item-text="valor"
            :item-value="(val) => parseInt(val.id)"
            :rules="$validate(['required'])"
            label="Entidad previsora"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex md4>
          <v-text-field
            label="Nro. NUA/CUA"
            required
            v-model="form.nro_nua"
            :rules="$validate(['required'])"
            maxlength="25"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md4>
          <v-autocomplete
            v-model="form.id_parametro_tipo_fondo"
            :items="tipo_fondo_pensiones"
            item-text="valor"
            :item-value="(val) => parseInt(val.id)"
            label="Tipo de fondo de pensiones"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex md6>
          <v-text-field
            label="Nombre de Banco"
            required
            v-model="form.banco"
            :rules="$validate(['required'])"
            class="mayuscula"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md6>
          <v-text-field
            type="number"
            label="Nro. de cuenta bancaria"
            required
            v-model="form.nro_cuenta_bancaria"
            :rules="$validate(['required'])"
            maxlength="20"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>

        <v-flex md4>
          <v-text-field
            label="Colegio de profesional al que pertenece"
            v-model="form.colegio_profesional"
            maxlength="50"
            class="mayuscula"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md4>
          <v-text-field
            label="Nro. de registro profesional (RP)"
            v-model="form.nro_registro_profesional"
            class="mayuscula"
            maxlength="50"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>
        <v-flex md4>
          <v-text-field
            v-model="form.fecha_reg_profesional"
            label="Fecha registro profesional"
            type="date"
            :disabled="this.estado == 0"
          >
          </v-text-field>
        </v-flex>
        <v-flex md4>
          <v-text-field
            type="number"
            label="Nro. de libreta de servicio militar"
            required
            v-model="form.libreta_serv_militar"
            maxlength="20"
            :rules="[
              (v) => {
                if (v < 0) return 'El campo no puede ser negativo.';
                if (v >= 10000000000000000000)
                  return 'No puede ingresar un número tan grande.';
                return true;
                return true;
              },
            ]"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>

        <v-flex md4>
          <v-autocomplete
            v-model="form.anio_serv_militar"
            :items="anios"
            item-text="anio"
            item-value="anio"
            label="Año"
            :disabled="this.estado == 0"
          ></v-autocomplete>
        </v-flex>
        <v-flex md12>
          <v-text-field
            label="Categoría de licencia"
            required
            v-model="form.nro_licencia_conducir"
            maxlength="30"
            :disabled="this.estado == 0"
          ></v-text-field>
        </v-flex>

        <v-flex md3>
          <div id="preview">
            <img v-if="img_url" :src="img_url" height="150" width="150" />
          </div>
        </v-flex>

        <v-flex md12>
          <input
            type="file"
            ref="file"
            @change="cargarImagen"
            accept="image/*"
          />
          <br />
          <v-flex xs3 v-if="this.img_error">
            <small class="error--text text-required">{{
              this.img_error_message
            }}</small>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-container>
    <v-card-actions>
      <small class="error--text text-required"
        >* Los campos son obligatorios</small
      >

      <!-- <v-btn @click="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn> -->
          <v-flex md12 xs12>
            <v-btn
        v-if="estado == 1"
        color="primary"
        type="submit"
        :disabled="!valid"
        :loading="loading"
      >
        <v-icon dark>check</v-icon> {{ $t("common.save") }}
      </v-btn>
          </v-flex>
     
    </v-card-actions>
  </v-form>
</template>

<script>
import validate from "@/common/mixins/validate";
import axios from "axios";

export default {
  props: ["persona"],
  mixins: [validate],
  computed: {
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  data() {
    return {
      dialog: false,
      form: this.persona,
      img_url: "",
      imagen: null,
      movilidad: {},
      valid: true,
      tipo_de_documentos: [],
      tipo_expedido: [],
      tipo_cargo: [],
      tipo_puesto: [],
      unidades: [],
      movilidad: {},
      date: new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      estado_boton: false,
      loading: false,
      respuestaf: [],
      itemsDisponibles: [],
      info: null,
      inf: [],
      anios: [],
      estado_civil: [],
      entidad_previsora: [],
      tipo_fondo_pensiones: [],
      paises: [],
      ciudades: [],
      departamentos: [],
      generos: [],
      estados_ficha: [],
      estado: [],
      rol: [],
      tipo_sangre: [],

      avatar: null,
      saving: false,
      saved: false,
      sw: false,
      img_error: false,
      img_error_message: "",
    };
  },
  mounted() {
    this.$refs.form.validate();
    this.getImagen();

    this.rangeYear();
    this.obtenerEstadoCivil();
    this.obtenerTipoSangre();
    this.obtenerEntidadPrevisora();
    this.obtenerDepartamentos();
    this.obtenerTipoFondo();
    this.obtenerGenero();
    this.obtenerPaises();
    this.obtenerCiudades();
    this.obtenerEstadoFicha();
  },
  methods: {
    cargarImagen() {
      this.sw = true;
      this.imagen = this.$refs.file.files[0];
      const img = this.imagen;

      const extenciones = ["png", "jpeg", "jpg", "gif"];
      let nm = img.name.split(".");

      const maxSize = 2000000;
      const extencion = nm[nm.length - 1];
      if (
        extenciones.filter((e) => e == extencion).length > 0 &&
        this.imagen.size <= maxSize
      ) {
        this.img_url = URL.createObjectURL(this.imagen);
        this.img_error = false;
        this.img_error_message = "";
      } else {
        if (extenciones.filter((e) => e == extencion).length == 0) {
          this.img_error = true;
          this.img_error_message = "Imagen no valida.";
        } else if (this.imagen.size > maxSize) {
          this.img_error = true;
          this.img_error_message = "La imagen excede el tamaño permitido.";
        }
      }
    },
    async getImagen() {
      this.img_url = require("../../../../assets/images/Usariosinimagen.png");
      try {
        let id = this.form.id;
        let respuesta = await this.$service.graphql({
          query: `
           query{
              persona(id:${id}){
                  foto   
              }
            }
          `,
        });
        let url = process.env.API_URL;
        url = url.substring(0, url.length - 4);
        if (respuesta.persona.foto != null) {
          this.img_url = url + respuesta.persona.foto;
        }
      } catch (error) {
        this.img_url = require("../../../../assets/images/Usariosinimagen.png");
      }
    },
    async subirImagen() {
      let formData = new FormData();
      formData.append("file", this.imagen);
      try {
        let res = await this.$http.post(
          process.env.API_URL + "public/upload",
          formData
        );
        return res.data;
      } catch (error) {
        console.log(error);
      }
    },
    convertirMayuscula(valor) {
      return valor.toUpperCase();
    },
    rangeYear() {
      const max = new Date().getFullYear();
      const min = max - 100;
      const years = [];
      for (let i = max; i >= min; i--) {
        years.push(i);
      }
      this.anios = years;
      return years;
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async obtenerTipoSangre() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"tipo_sangre"){
              rows{
                id
                valor
              }
            }
          }
        `,
      });
      this.tipo_sangre = respuesta.params.rows;
    },
    async obtenerEstadoCivil() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"estado_civil"){
              rows{
                id
                valor
              }
            }
          }
        `,
      });
      this.estado_civil = respuesta.params.rows;
    },
    async obtenerEntidadPrevisora() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"entidad_previsora"){
              rows{
                id
                valor
              }
            }
          }
        `,
      });
      this.entidad_previsora = respuesta.params.rows;
    },
    async obtenerTipoFondo() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"tipo_entidad_previsora"){
              rows{
                id
                valor
              }
            }
          }
        `,
      });
      this.tipo_fondo_pensiones = respuesta.params.rows;
    },

    async obtenerPaises() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            paisess{
              rows{
                id
                codigo
                pais
              }
            }
          }
        `,
      });

      this.paises = respuesta.paisess.rows;
    },

    async obtenerCiudades() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
                ciudadess(id_pais:120){
                  rows{
                    id
                    ciudad
                    paises_codigo
                    id_pais
                  }
                }
              }
        `,
      });

      this.ciudades = respuesta.ciudadess.rows;
    },

    async obtenerGenero() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"SEXO"){
              rows{
                id
                valor
              }
            }
          }
        `,
      });
      this.generos = respuesta.params.rows;
    },
    async obtenerDepartamentos() {
      let respuesta = await this.$service.graphql({
        query: `
          query{
            params(tipo:"departamentos"){
              rows{
                id
                valor
              }
            }
          }
        `,
      });
      this.departamentos = respuesta.params.rows;
    },
    // async obtenerEstadoFicha() {
    //   let user = this.$storage.get("user");
    //   this.rol=user.roles[0].id;
    //   let respuesta = await this.$service.graphql({
    //             query:`query{
    //                   runQuery(consulta:"select * from persona.v_listaficha vl  where id_persona =${parseInt(this.$route.params.id)}"){
    //                     respuesta
    //                   }
    //                 }
    //               `,
    //             })
    //   this.estados_ficha = respuesta.runQuery.respuesta[0];
    //   this.estado=respuesta.runQuery.respuesta[0].habilitado

    // },
    async obtenerEstadoFicha() {
      let user = this.$storage.get("user");
      let id_persona;
      if (this.$route.params.id) {
        id_persona = this.$route.params.id;
      } else {
        id_persona = user.id_persona;
      }
      this.rol = user.roles[0].id;
      let respuesta = await this.$service.graphql({
        query: `
            query{
            vListafichas(id_persona:${id_persona}){
            rows{
            id_persona
            nombre
            nro_doc
            id_estado_ficha
            estado_ficha
            habilitado
            item
            id_unidad
            unidad 
            }
            }
            }
            `,
      });
      this.estados_ficha = respuesta.vListafichas.rows;
      this.estado = this.estados_ficha[0].habilitado;
      let roles = user.roles;
      roles.forEach(element => {
      if(element.id==115){
        this.estado=1
      }
    });
    },
    async save() {
      if (this.img_error) return;
      this.$confirm("¿Está seguro de registrar los datos personales básicos?", async() => {
        if (this.$refs.form.validate()) {
        const id = this.form.id;
        delete this.form.id;
        //delete this.form.zona;
        delete this.form.nro;
        delete this.form.calle;
        delete this.form.genero;
        delete this.form.correo;

        this.form.id_parametro_sexo = parseInt(this.form.id_genero);
        console.log("///////////77//",this.form.id_genero,this.form.id_parametro_sexo)
        if (this.form.id_genero == 1) {
          this.form.sexo = "F";
          
        } else {
          this.form.sexo = "M";
        }

        if (this.form.pais_nacimiento != 120) {
          this.form.id_parametro_departamento = null;
        }
        if (
          this.form.fecha_reg_profesional == "" ||
          this.form.fecha_reg_profesional == null
        ) {
          this.form.fecha_reg_profesional = null;
        }
        if (this.sw) {
          this.form.foto = await this.subirImagen();
          let url = process.env.API_URL;
          url = url.substring(0, url.length - 4);
          this.img_url = url + this.form.foto;
          this.sw = !this.sw;
        }
        this.$service
          .graphql({
            query: `
					mutation edit($id:ID!,$persona: EditPersona!) {
						personaEdit(id:$id,persona: $persona) {
							id
						}
					}
				`,
            variables: {
              id,
              persona: this.form,
            },
          })
          .then(async (response) => {
            if (response) {
              this.$message.success();
              this.form.id = id;
             document.location.reload();
            }
          });
        this.loading = false;
      }
        });
    },
    //  sanitizeDateString (dateString, type = 'date') {
    //     const [year, month = 1, date = 1] = dateString.split('-');
    //     return `${year}-${pad(month)}-${pad(date)}`.substr(0, { date: 10, month: 7, year: 4 }[type]);
    //   },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/ficha_personal/components/DatosPersonalesBasicos.vue